module.exports = __webpack_public_path__ + "6973fd888594e4c520c7748e18f57f17.png";